const actions = {
  GET_INVOICES_REQUEST: "GET_INVOICES_REQUEST",
  GET_INVOICES_SUCCESS: "GET_INVOICES_SUCCESS",

  UPLOAD_INVOICES_REQUEST: "UPLOAD_INVOICES_REQUEST",
  UPLOAD_INVOICES_SUCCESS: "UPLOAD_INVOICES_SUCCESS",

  getInvoicesData: (params) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_INVOICES_REQUEST,
        ...params,
      });
    };
  },

  uploadInvoice: (params) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPLOAD_INVOICES_REQUEST,
        ...params,
      });
    };
  },
};
export default actions;
